import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';

import { Update } from '../../../../_models/update';
import { Template } from '../../../../_models/template';
import { CardService } from '../../card.service';
import { CardSvg } from '../../../../_models/card-svg';



@Component({
  selector: 'app-upload-photo',
  templateUrl: './upload-photo.component.html',
  styleUrls: ['./upload-photo.component.css']
})
export class UploadPhotoComponent implements OnInit, OnChanges {
  @Input() template: Template;
  @Output() svg = new EventEmitter<string>();
  cardSvg:CardSvg;
  templateHasImageField = false;

  constructor(public cardService: CardService) { }

  ngOnInit() {
    this.templateHasImageField = this.cardSvg.hasPhoto;
  }

  ngOnChanges() {
    this.cardSvg = new CardSvg(this.template.svg);
  }

  onFileUpload(event:any) {
    let newImage = event.target.files[0];
    //TODO: add max file size validation
    this.cardService.uploadImage(newImage).subscribe(data => {
      this.updateSVGImagePreview(data);
    });
  }

  updateSVGImagePreview(url:string) {
    this.cardSvg.setValue(CardSvg.photo_selector, url);
    this.template.svg = this.cardSvg.svg_html;
    this.svg.emit(this.template.svg);
  }

}



// WEBPACK FOOTER //
// /app/src/app/hq/cards/modify-card/upload-photo/upload-photo.component.ts